export default "__VITE_ASSET__DWWBuZ$X__"